import { render, staticRenderFns } from "./wasteInsulate1.vue?vue&type=template&id=abec037c&scoped=true&"
import script from "./wasteInsulate1.vue?vue&type=script&lang=js&"
export * from "./wasteInsulate1.vue?vue&type=script&lang=js&"
import style0 from "./wasteInsulate1.vue?vue&type=style&index=0&id=abec037c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abec037c",
  null
  
)

export default component.exports